/**
 * 运营管理接口
 */
export default {
  // 运营管理-机构管理-列表
  common_queryOrgList: {
    // mock: true,
    control: 'dyc/saas/common/user/org/qryEnterpriseOrgListPage'
  },
  // 运营管理-机构管理-机构授权
  common_grantToOrg: {
    // mock: true,
    control: 'dyc/common/user/authority/org/grantToOrg'
  },
  // 运营管理-机构管理-机构类型
  common_qryOrgTypeConfigListPage: {
    // mock: true,
    control: 'dyc/saas/common/orgType/qryOrgTypeConfigListPage'
  },
  // 运营管理-机构用户-机构管理-新增
  common_addEnterpriseOrg: {
    // mock: true,
    control: 'dyc/common/user/org/addEnterpriseOrg'
  },
  // 运营管理-机构用户-机构管理-详情
  common_qryEnterpriseOrgDetail: {
    // mock: true,
    control: 'dyc/common/user/org/qryEnterpriseOrgDetail'
  },
  // 运营管理-机构用户-机构管理-树形列表
  common_queryEnterpriseOrgTree: {
    // mock: true,
    control: 'dyc/saas/common/user/org/queryEnterpriseOrgTree'
  },
  // 运营管理-机构用户-机构管理-树形列表(重构)
  re_queryEnterpriseOrgTree: {
    // mock: true,
    control: 'dyc/saas/common/enterprise/qryEnterpriseInfoTree'
  },
  // 运营管理-机构用户-机构管理-停用删除
  common_deleteStartStopEnterpriseOrg: {
    // mock: true,
    control: 'dyc/common/user/org/deleteStartStopEnterpriseOrg'
  },
  // 运营管理-机构用户-机构管理-机构授权
  common_alreadyAndNorRoles: {
    // mock: true,
    control: 'dyc/common/user/authority/org/alreadyAndNorRoles'
  },
  // 运营管理-机构用户-机构管理-可选择机构类型
  common_qryOrgTypeConfigChoose: {
    // mock: true,
    control: 'dyc/saas/common/orgType/qryOrgTypeConfigChoose'
  },
  // 运营管理-机构用户-机构管理-修改
  common_updateEnterpriseOrg: {
    // mock: true,
    control: 'dyc/common/user/org/updateEnterpriseOrg'
  },
  // 运营管理-机构用户-管理员管理-列表
  amc_adminManager: {
    // mock: true,
    control: 'dyc/common/user/author/adminManager/search'
  },
  // 运营管理-机构用户-新增管理员管理-列表
  amc_adminUser: {
    // mock: true,
    control: 'dyc/common/user/author/search'
  },
  // 运营管理-机构用户-管理员管理-管理员树列表获取第一级
  amc_getOrgByOrgId: {
    // mock: true,
    control: 'dyc/common/user/author/org/getOrgByOrgId'
  },
  // 运营管理-机构用户-管理员管理-管理员树列表获取第一级
  amc_queryInnerEnterpriseOrgTree: {
    // mock: true,
    control: 'dyc/saas/common/enterprise/queryEnterpriseOrgTree'
  },
  // 运营管理-机构用户-管理员管理-管理员树列表获取第一级
  amc_updateManager: {
    // mock: true,
    control: 'dyc/common/user/author/adminManager/updateManager'
  },
  // 运营管理-机构用户-管理员管理-管理员展开列表
  amc_getOrgByParentId: {
    // mock: true,
    control: 'dyc/common/user/author/org/getOrgByParentId'
  },
  // 运营管理-机构用户-管理员管理-移除
  amc_adminManagerDel: {
    // mock: true,
    control: 'dyc/common/user/author/adminManager/del'
  },
  // 运营管理-机构用户-管理员管理-发布角色列表
  amc_alreadyAndNorRolesByOrgTreePath: {
    // mock: true,
    control: 'dyc/common/user/author/adminManager/alreadyAndNorRolesByOrgTreePath'
  },
  // 运营管理-机构用户-管理员管理-发布角色
  amc_grantRoleToManager: {
    // mock: true,
    control: 'dyc/common/user/author/adminManager/grantRoleToManager'
  },
  // 运营管理-机构用户-管理员管理-发布岗位列表
  amc_alreadyAndNorStationsByOrgTreePath: {
    // mock: true,
    control: 'dyc/common/user/author/adminManager/alreadyAndNorStationsByOrgTreePath'
  },
  // 运营管理-机构用户-管理员管理-发布岗位
  amc_grantStationToManager: {
    // mock: true,
    control: 'dyc/common/user/author/adminManager/grantStationToManager'
  },
  // 运营管理-机构用户-管理员管理-新增管理员
  amc_addManager: {
    // mock: true,
    control: 'dyc/common/user/author/adminManager/addManager'
  },
  // 运营管理-机构用户-管理员管理-发布资源-子系统
  amc_selectByUser: {
    // mock: true,
    control: 'dyc/common/user/author/application/selectByUser'
  },
  //  运营管理-机构用户-管理员管理-发布资源接口
  amc_configMenusByOrgTreePath: {
    // mock: true,
    control: 'dyc/common/user/author/menu/configMenusByOrgTreePath'
  },
  //  运营管理-机构用户-管理员管理-菜单
  amc_selectMenusByOrgTreePath: {
    // mock: true,
    control: 'dyc/common/user/author/menu/selectMenusByOrgTreePath'
  },
  // 运营管理-机构用户-用户管理-详情
  common_qryMemberDetail: {
    // mock: true,
    control: 'dyc/common/user/mem/qryMemberDetail'
  },
  // 用户详情信息获取
  common_qryUserInfoDetail: {
    // mock: true,
    control: 'dyc/saas/common/user/qryUserInfoDetail'
  },
  // 运营管理-机构用户-用户管理-新增
  common_addMember: {
    // mock: true,
    control: 'dyc/common/user/mem/addMember'
  },
  // 运营管理-机构用户-用户管理-修改
  common_updateMember: {
    // mock: true,
    control: 'dyc/common/user/mem/updateMember'
  },
  // 运营管理-机构用户-用户管理-授权树
  common_authUser: {
    // mock: true,
    control: 'dyc/common/user/authority/user/authUser'
  },
  // 运营管理-机构用户-用户管理-授权
  common_authUserCommit: {
    // mock: true,
    control: 'dyc/common/user/author/authUserCommit'
  },
  // 运营管理-机构用户-用户管理-调岗
  common_submitMemChangePozition: {
    // mock: true,
    control: 'dyc/common/user/mem/submitMemChangePozition'
  },
  // 运营管理-机构用户-用户管理-查看调岗历史
  common_queryMemChangePozitionHis: {
    // mock: true,
    control: 'dyc/common/user/mem/queryMemChangePozitionHis'
  },
  // 运营管理-机构用户-用户管理-重置密码
  common_resetPsw: {
    // mock: true,
    control: 'dyc/common/user/mem/resetPsw'
  },
  // 运营管理-机构用户-用户管理-停用启用删除
  common_stopUsedInnerEnterpriseUser: {
    // mock: true,
    control: 'dyc/common/user/stopUsedInnerEnterpriseUser'
  },
  // 运营管理-基础数据设置-敏感词
  data_getDycUccSpuSearchforwordsListQry: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getDycUccSpuSearchforwordsListQry'
  },
  // 运营管理-基础数据设置-敏感词新增
  data_addHotSearchBlackList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/addUccSearchWordBlack'
  },
  // 运营管理-基础数据设置-敏感词删除
  data_delHotSearchBlackList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/delHotSearchBlackList'
  },
  // 运营管理-基础数据设置-敏感词修改
  data_dealDycUccSpuSearchforwordsEdit: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealDycUccSpuSearchforwordsEdit'
  },
  // 运营管理-基础数据设置-计量单位新增
  data_addmeasureInfo: {
    // mock: true,
    control: 'dyc/busicommon/commodity/addmeasureInfo'
  },
  // 运营管理-基础数据设置-计量单位删除
  data_deleteMeasure: {
    // mock: true,
    control: 'dyc/busicommon/commodity/deleteMeasure'
  },
  // 运营管理-基础数据设置-推荐搜索词列表查询
  data_qrySearchHotWord: {
    // mock: true,
    control: 'dyc/busicommon/commodity/qrySearchHotWord'
  },
  // 运营管理-基础数据设置-推荐搜索词新增
  data_addHotWord: {
    // mock: true,
    control: 'dyc/busicommon/commodity/addHotWord'
  },
  // 运营管理-基础数据设置-推荐搜索词修改
  data_dealSpuThesearchtermEdit: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealSpuThesearchtermEdit'
  },
  // 运营管理-基础数据设置-推荐搜索词删除
  data_dealSpuThesearchtermDel: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealSpuThesearchtermDel'
  },
  // 运营管理-基础数据设置-商品搜索排序列表查询
  data_getDycUccSpuSearchrankingsListQry: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getDycUccSpuSearchrankingsListQry'
  },
  // 运营管理-基础数据设置-商品搜索排序新增
  data_dealSpuSearchrankingsAdd: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealSpuSearchrankingsAdd'
  },
  // 运营管理-基础数据设置-商品搜索排序删除
  data_dealSpuSearchrankingsDel: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealSpuSearchrankingsDel'
  },
  // 运营管理-基础数据设置-商品搜索排序修改
  data_dealSpuSearchrankingsEdit: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealSpuSearchrankingsEdit'
  },
  // 运营管理-基础数据设置-基础货币列表
  data_getUccSpuCurrencyListQry: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getUccSpuCurrencyListQry'
  },
  // 运营管理-基础数据设置-基础货币新增
  data_dealUccSpuCurrencyAdd: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealUccSpuCurrencyAdd'
  },
  // 运营管理-基础数据设置-基础货币删除
  data_dealUccSpuCurrencyDel: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealUccSpuCurrencyDel'
  },
  // 运营管理-基础数据设置-基础货币修改
  data_dealUccSpuCurrencyEdit: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealUccSpuCurrencyEdit'
  },
  // 运营管理-计费管理-成交服务费-优惠减免确定
  dyc_dealPayServiceBillProcess: {
    // mock: true,
    control: 'dyc/fsc/dealPayServiceBillProcess'
  },
  // 运营管理-计费管理-成交服务费-手动确认
  dyc_dealPayServicePayConfirmForYunying: {
    // mock: true,
    control: 'dyc/fsc/dealPayServicePayConfirmForYunying'
  },
  // 运营管理-供应商签约单列表查询API
  dyc_getSupSignContractApprovalList: {
    // mock: true,
    control: 'dyc/supplier/signContract/getSupSignContractApprovalList'
  },
  // 运营管理-供应商签约单详情查询API
  dyc_getSupSignContractDetail: {
    // mock: true,
    control: 'dyc/supplier/signContract/getSupSignContractDetail'
  },
  // 运营管理-供应商签约单品类列表查询API
  dyc_getSalesCategoryList: {
    // mock: true,
    control: 'dyc/supplier/signContract/getSalesCategoryList'
  },
  // 运营管理-供应商签约单流转信息列表查询
  dyc_getSupSignContractLogList: {
    // mock: true,
    control: 'dyc/supplier/signContract/getSupSignContractLogList'
  },
  // 运营管理-供应商签约已选未选单品类列表查询API
  dyc_getUccCategoryList: {
    // mock: true,
    control: 'dyc/supplier/signContract/getUccCategoryList'
  },
  // 运营管理-供应商签约单办理API
  dyc_dealSupSignContractHandle: {
    // mock: true,
    control: 'dyc/supplier/signContract/dealSupSignContractHandle'
  },
  // 运营管理-运营管理审批-成交服务费优惠减免审批列表
  dyc_qryServicePayApprovalList: {
    // mock: true,
    control: 'dyc/fsc/qryServicePayApprovalList'
  },
  // 运营管理-运营管理审批-成交服务费优惠减免批量审批驳回
  dyc_dealDycOrderBatchApproval: {
    // mock: true,
    control: 'dyc/fsc/dealDycOrderBatchApproval'
  },
  // 运营管理-运营管理审批-成交服务费优惠减免审批确认
  dyc_dealOrderApproval: {
    // mock: true,
    control: 'dyc/fsc/dealOrderApproval'
  },
  // 运营管理-计费管理-成交服务费、平台使用费优惠减免位数保留规则查询
  dyc_qryListDetail: {
    // mock: true,
    control: 'dyc/fsc/qryListDetail'
  },
  // 角色管理-角色详情查询 内部角色
  rest_qryInternalRoleDetails: {
    // mock: true,
    control: 'dyc/saas/common/user/qryInternalRoleDetails'
  },
  // 角色管理-角色列表-待分配岗位组
  rest_qryAllJobGroupList: {
    // mock: true,
    control: 'dyc/saas/common/user/qryAllJobGroupList'
  },
  // 角色管理-角色列表-已分配岗位组
  rest_qrySelectedJobGroupList: {
    // mock: true,
    control: 'dyc/saas/common/user/qrySelectedJobGroupList'
  },
  // 角色管理-角色列表-角色新增删除岗位组
  rest_updateRoleJobGroup: {
    // mock: true,
    control: 'dyc/saas/common/user/updateRoleJobGroup'
  },
  // 角色管理-角色列表查询
  rest_selectRoles: {
    // mock: true,
    control: 'dyc/saas/common/role/getroleInfoList'
  },
  // 角色管理-角色列表查询（重构）
  rest_selectRolesRe: {
    // mock: true,
    control: 'dyc/saas/common/role/getroleInfoList'
  },
  // 角色管理-角色详情查询
  rest_selectRole: {
    // mock: true,
    control: 'dyc/saas/common/role/getRoleInfoDetail'
  },
  // 角色管理-角色新增
  rest_creatRole: {
    // mock: true,
    control: 'dyc/saas/common/role/createRoleInfo'
  },
  // 角色管理-角色修改
  rest_updateRole: {
    // mock: true,
    control: 'dyc/saas/common/role/modifyRoleInfo'
  },
  // 角色管理-角色停用
  rest_roleStop: {
    // mock: true,
    control: 'dyc/saas/common/role/disableRoleInfo'
  },
  // 角色管理-角色启用
  rest_roleRestart: {
    // mock: true,
    control: 'dyc/saas/common/role/enableRoleInfo'
  },
  // 角色管理-角色删除
  rest_roleDelete: {
    // mock: true,
    control: 'dyc/saas/common/role/deleteRoleInfo'
  },
  // 角色管理- 判断角色能否删除停止
  rest_checkRoleDelete: {
    // mock: true,
    control: 'dyc/saas/common/user/deleteOrStopRoleCheck'
  },
  // 角色管理-角色用户授权情况查询
  rest_alreadyAndNorUsers: {
    // mock: true,
    control: 'dyc/saas/common/user/getUserListByRole'
  },
  // 角色管理-
  rest_getOrgTreeByTreePathList: {
    // mock: true,
    control: 'dyc/saas/common/role/getOrgTreeByTreePathList'
  },
  // 角色管理-角色机构授权情况查询
  rest_alreadyAndNorOrg: {
    // mock: true,
    control: 'dyc/saas/common/enterprise/getOrgListBy'
  },
  // 角色管理-角色用户授权
  rest_authUserCommit: {
    // mock: true,
    control: 'dyc/saas/common/role/dealRoleUserList'
  },
  // 角色管理-角色机构授权
  rest_orgCommit: {
    // mock: true,
    control: 'dyc/saas/common/role/dealRoleOrgList'
  },
  // 角色管理-角色岗位授权情况查询
  rest_alreadyAndNorRoleStationNew: {
    // mock: true,
    control: 'dyc/saas/common/user/station/alreadyAndNorRoleStationNew'
  },
  // 角色管理-角色岗位授权
  rest_saveRoleStations: {
    // mock: true,
    control: 'dyc/common/user/station/saveRoleStations'
  },
  // 角色管理-角色菜单列表查询
  rest_selMenusByUser: {
    // mock: true,
    control: 'dyc/saas/common/role/getPowerMenuListByRole'
  },
  // 角色管理-发布资源情况查询API
  rest_publishMenusInitial: {
    // mock: true,
    control: 'dyc/common/user/author/adminManager/publishMenusInitial'
  },
  // 内部机构树
  rest_queryInnerEnterpriseOrgTree: {
    // mock: true,
    control: 'dyc/saas/common/enterprise/queryEnterpriseOrgTree'
  },
  // 外部机构树
  rest_queryExtEnterpriseOrgTree: {
    // mock: true,
    control: 'dyc/common/user/org/queryExtEnterpriseOrgTree'
  },
  // 平台使用费业务费用收取规则列表API
  rest_qryPlatformUsageListPage: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryPlatformUsageListPage'
  },
  // 平台使用费业务费用收取规则列表API-删除
  rest_delUniteParam: {
    // mock: true,
    control: 'dyc/config/cfc/unite/delUniteParam'
  },
  // 平台使用费业务费用收取规则-企业供应商下拉列表
  rest_qryDropDwonListExceptAccess: {
    // mock: true,
    control: 'dyc/saas/common/user/enterprise/qryDropDwonListExceptAccess'
  },
  // 平台使用费业务费用收取规则-新增
  rest_addPlatformUsage: {
    // mock: true,
    control: 'dyc/config/cfc/unite/addPlatformUsage'
  },
  // 平台使用费业务费用收取规则-详情
  rest_qryPlatformUsageDetail: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryPlatformUsageDetail'
  },
  // 平台使用费业务费用收取规则-修改
  rest_updatePlatformUsage: {
    // mock: true,
    control: 'dyc/config/cfc/unite/updatePlatformUsage'
  },
  // 成交服务费违约限制规则列表API
  rest_qryDealBreachListPage: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryDealBreachListPage'
  },
  // 成交服务费优惠减免操作查询接口
  rest_qryUniteParamDetailsByCodeAndId: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryUniteParamDetailsByCodeAndId'
  },
  // 成交服务费违约限制规则列表-新增API
  rest_addDealBreach: {
    // mock: true,
    control: 'dyc/config/cfc/unite/addDealBreach'
  },
  // 成交服务费违约限制规则列表-详情
  rest_qryDealBreachDetail: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryDealBreachDetail'
  },
  // 成交服务费违约限制规则列表-修改
  rest_updateDealBreach: {
    // mock: true,
    control: 'dyc/config/cfc/unite/updateDealBreach'
  },
  // 平台服务费违约限制规则列表
  rest_qryPlatformBreachListPage: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryPlatformBreachListPage'
  },
  // 平台服务费违约限制规则列表-新增
  rest_addPlatformBreach: {
    // mock: true,
    control: 'dyc/config/cfc/unite/addPlatformBreach'
  },
  // 平台服务费违约限制规则列表-修改
  rest_updatePlatformBreach: {
    // mock: true,
    control: 'dyc/config/cfc/unite/updatePlatformBreach'
  },
  // 平台服务费违约限制规则列表-详情
  rest_qryPlatformBreachDetail: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryPlatformBreachDetail'
  },
  // 系统基础货币设置列表API
  rest_qrySysCurrencyListPage: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qrySysCurrentListPage'
  },
  // 系统基础货币设置列表-修改
  rest_updateSysCurrency: {
    // mock: true,
    control: 'dyc/config/cfc/unite/updateSysCurrent'
  },
  // 企业机构列表API
  rest_qryEnterpriseOrgListPage: {
    // mock: true,
    control: 'dyc/saas/common/user/org/qryEnterpriseOrgListPage'
  },
  // 内部供应商信息维护API
  rest_dealInnerEnterpriseOrg: {
    // mock: true,
    control: 'dyc/common/user/org/dealInnerEnterpriseOrg'
  },
  // 企业机构详情API
  rest_qryEnterpriseOrgDetail: {
    // mock: true,
    control: 'dyc/common/user/org/qryEnterpriseOrgDetail'
  },
  // 企业机构详情API-内部 （单独获取邮箱、手机、企业联系人）
  rest_qrySupplierInfoDetail: {
    // mock: true,
    control: 'dyc/supplier/qrySupplierInfoDetail'
  },
  // 客商基本信息审批列表
  rest_qryEnterpriseOrgAuditListPage: {
    // mock: true,
    control: 'dyc/common/user/org/qryEnterpriseOrgAuditListPage'
  },
  // 客商基本信息审批
  rest_dealEnterpriseOrgAudit: {
    // mock: true,
    control: 'dyc/common/user/org/dealEnterpriseOrgAudit'
  },
  // 客商基本信息审批详情
  rest_qryEnterpriseOrgAuditDetail: {
    // mock: true,
    control: 'dyc/common/user/org/qryEnterpriseOrgAuditDetail'
  },
  // 客商基本信息审批详情
  rest_qryMemberListPage: {
    // mock: true,
    control: 'dyc/saas/common/user/mem/qryMemberListPage'
  },
  // 用户信息修改
  rest_updateMember: {
    // mock: true,
    control: 'dyc/common/user/mem/updateMember'
  },
  // 角色菜单配置API
  rest_configMenus: {
    // mock: true,
    control: 'dyc/saas/common/role/dealRoleMenuRel'
  },
  // 角色tab
  rest_getApplicationList: {
    // mock: true,
    control: 'dyc/saas/common/application/getApplicationList'
  },
  // 角色发布资源授权
  rest_publishMenusSave: {
    // mock: true,
    control: 'dyc/saas/common/role/dealRoleMenuPower'
  },
  // 内部供应商机构数列表API
  rest_queryInnerSupEnterpriseOrgTreeList: {
    // mock: true,
    control: 'dyc/common/user/org/queryInnerSupEnterpriseOrgTreeList'
  },
  // 成交服务费业务费用收取规则分页查询API
  rest_qryPageServiceFeeRule: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryPageServiceFeeRule'
  },
  // 成交服务费业务费用收取规则新增API
  rest_addServiceFeeRule: {
    // mock: true,
    control: 'dyc/config/cfc/unite/addServiceFeeRule'
  },
  // 成交服务费业务费用收取规则详情查询API
  rest_qryDetailServiceFeeRule: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryDetailServiceFeeRule'
  },
  // 成交服务费业务费用收取规则更新API
  rest_updateServiceFeeRule: {
    // mock: true,
    control: 'dyc/config/cfc/unite/updateServiceFeeRule'
  },
  // 成交服务费业务费用收取规则更新API
  rest_dealEnterpriseOrgAuditBatch: {
    // mock: true,
    control: 'dyc/common/user/org/dealEnterpriseOrgAuditBatch'
  },
  // 客商基本信息审批查看审批情况
  rest_qrySupplierAuditLogList: {
    // mock: true,
    control: 'dyc/supplier/qrySupplierAuditLogList'
  },
  // 智能客服管理-客服管理查询
  common_qryCsList: {
    // mock: true,
    control: 'dyc/saas/common/user/qryCsList'
  },
  // 智能客服管理-技能组查询
  common_qrySkillGroupList: {
    // mock: true,
    control: 'dyc/saas/common/user/qrySkillGroupList'
  },
  // 智能客服管理-客服角色查询
  common_qryCsRoleList: {
    // mock: true,
    control: 'dyc/saas/common/user/qryCsRoleList'
  },
  // 智能客服管理-人员查询
  common_qryCsWaitMemberList: {
    // mock: true,
    control: 'dyc/saas/common/user/qryCsWaitMemberList'
  },
  // 智能客服管理-新增
  common_dealCustServiceCreate: {
    // mock: true,
    control: 'dyc/saas/common/user/dealCustServiceCreate'
  },
  // 智能客服管理-修改
  common_dealCustServiceEdit: {
    // mock: true,
    control: 'dyc/sass/common/user/dealCustServiceEdit'
  },
  // 智能客服管理-删除
  common_dealCustServiceDelete: {
    // mock: true,
    control: 'dyc/saas/common/user/dealCustServiceDelete'
  },
  // 供应商联系人职位设置列表
  rest_getEnterpriseContactPositionList: {
    // mock: true,
    control: 'dyc/saas/common/position/getEnterpriseContactPositionList'
  },
  // 供应商联系人职位新增或修改
  rest_saveEnterpriseContactPosition: {
    // mock: true,
    control: 'dyc/saas/common/position/saveEnterpriseContactPosition'
  },
  rest_delEnterpriseContactPosition: {
    // mock: true,
    control: 'dyc/saas/common/position/delEnterpriseContactPosition'
  },
  //  ===========通知中心 start===============
  // 通知中心字典服务API
  dyc_geminiDicQueryDicByPCodes: {
    control: 'gemini/dic/queryDicByPCodes'
  },
  // 通知中心字典服务API
  dyc_geminiDicQueryDicByPCode: {
    control: 'gemini/dic/queryDicByPCode'
  },
  // 通知中心 通知中心公用模块查询接口
  dyc_geminiDicQueryModuleByCache: {
    control: 'gemini/dic/queryModuleByCache'
  },
  // 通知中心 - 通知分类列表查询
  dyc_geminiTypeGetList: {
    // mock: true,
    control: 'gemini/type/getList'
  },
  // 通知中心 通知分类列表操作-启停用API 修改API'
  dyc_geminiTypeEdit: {
    control: 'gemini/type/edit'
  },
  // 通知中心 通知分类列表操作 -删除API
  dyc_geminiTypeDelete: {
    control: 'gemini/type/delete'
  },
  // 通知中心 通知分类列表查看详情API
  dyc_geminiTypeGetDetail: {
    control: 'gemini/type/getDetail'
  },
  // 通知中心 通知分类新增API
  dyc_geminiTypeAdd: {
    control: 'gemini/type/add'
  },
  // ============
  // 通知中心  通知业务变量管理 列表查询API 新增通知模板 业务变量列表查询API
  dyc_geminiVariableGetListPage: {
    control: 'gemini/variable/getListPage'
  },
  // 通知中心 通知业务变量 详情查询API
  dyv_geminiVariableGetDetail: {
    control: 'gemini/variable/getDetail'
  },
  // 通知中心 通知业务变量 启用停用 修改API
  dyc_geminiVariableEdit: {
    control: 'gemini/variable/edit'
  },
  // 通知中心  通知业务变量 删除API
  dyc_geminiVariableDelete: {
    control: 'gemini/variable/delete'
  },
  // 通知中心 通知业务变量新增 API
  dyc_geminiVariableAdd: {
    control: 'gemini/variable/add'
  },
  // =================
  // 通知中心 通知模板管理  列表分页查询API
  dyc_geminiTemplateQryTemplatePageList: {
    control: 'gemini/template/qryTemplatePageList'
  },
  // 通知中心 通知模板管理 通知模板状态修改API
  dyc_geminiTemplateEditTemplateStatus: {
    control: 'gemini/template/editTemplateStatus'
  },
  // 通知中心 通知模板管理  通知模板删除API
  dyc_geminiTemplateDeleteTemplate: {
    control: 'gemini/template/deleteTemplate'
  },
  // 通知中心 通知模板管理 新增通知模板API
  dyc_geminiTemplateAddTemplateInfo: {
    control: 'gemini/template/addTemplateInfo'
  },
  // 通知中心 通知模板管理  模板详情查看API
  dyc_geminiTemplateQryTemplateDetails: {
    control: 'gemini/template/qryTemplateDetails'
  },
  // 通知中心 通知模板管理 模板信息修改API
  dyc_geminiTemplateEditTemplateInfo: {
    control: 'gemini/template/editTemplateInfo'
  },
  // ===================
  // 通知中心 通知任务列表分页查询API
  dyc_geminiTaskQryTaskPageList: {
    control: 'gemini/task/qryTaskPageList'
  },
  // 通知中心 通知任务 状态修改API
  dyc_geminiTaskUpdateTaskStatus: {
    control: 'gemini/task/updateTaskStatus'
  },
  // 通知中心 通知任务 删除API
  dyc_geminiTaskDeleteTaskInfo: {
    control: 'gemini/task/deleteTaskInfo'
  },
  // 通知中心 通知任务 复制API
  dyc_geminiTaskDuplicateTaskInfo: {
    control: 'gemini/task/duplicateTaskInfo'
  },
  // 通知中心 通知任务 点击名称查看详情API 操作查看API
  dyc_geminiTaskQryTaskDetails: {
    control: 'gemini/task/qryTaskDetails'
  },
  // 通知中心 新增通知任务  模板下拉框查询API
  dyc_geminiTemplateQryTemplateList: {
    control: 'gemini/template/qryTemplateList'
  },
  // 通知中心 通知任务  新增通知任务API
  dyc_geminiTaskAddTaskInfo: {
    control: 'gemini/task/addTaskInfo'
  },
  // 通知中心 通知任务详情 站内信数据查询接口
  dyc_geminiInnerMessageQryInnerMessageCount: {
    control: 'gemini/innerMessage/qryInnerMessageCount'
  },
  // 通知中心 通知任务修改 API
  dyc_geminiTaskUpdateTaskInfo: {
    control: 'gemini/task/updateTaskInfo'
  },
  // 通知中心 通知任务推送方式查询接口
  dyc_geminiSendTypeQrySendTypeList: {
    control: 'gemini/sendType/qrySendTypeList'
  },
  //  ===========通知中心 end===============
  // 运营管理 - 预算管理 - 采购限额管理 -列表
  dyc_getPurchaseLimitPageList: {
    control: 'dyc/saas/common/purchaseLimit/getPurchaseLimitPageList'
  },
  // 运营管理 - 预算管理 - 采购限额管理 -新增
  dyc_createPurchaseLimitConfig: {
    control: 'dyc/saas/common/purchaseLimit/createPurchaseLimitConfig'
  },
  // 运营管理 - 预算管理 - 采购限额管理 -停用
  dyc_disablePurchaseLimitConfig: {
    control: 'dyc/saas/common/purchaseLimit/disablePurchaseLimitConfig'
  },
  // 运营管理 - 预算管理 - 采购限额管理 -启用
  dyc_enablePurchaseLimitConfig: {
    control: 'dyc/saas/common/purchaseLimit/enablePurchaseLimitConfig'
  },
  // 运营管理 - 预算管理 - 采购限额管理 -详情
  dyc_getPurchaseLimitDetail: {
    control: 'dyc/saas/common/purchaseLimit/getPurchaseLimitDetail'
  },
  // 运营管理 - 预算管理 - 采购限额管理 -历史记录
  dyc_getPurchaseLimitHisPageList: {
    control: 'dyc/saas/common/purchaseLimit/getPurchaseLimitHisPageList'
  },
  // 运营管理 - 预算管理 - 授信管理 -历史记录 - 临时额度
  dyc_getTempCreditPageList: {
    control: 'dyc/saas/common/credit/getTempCreditPageList'
  },
  // 运营管理 - 预算管理 - 授信管理 - 临时额度详情
  dyc_getTempCreditDetail: {
    control: 'dyc/saas/common/credit/getTempCreditDetail'
  },
  // 运营管理 - 预算管理 - 授信管理 - 大额订单详情
  dyc_queryLowMarginLargeOrderApproval: {
    control: 'dyc/saas/mall/order/queryLowMarginLargeOrderApproval'
  },
  // 运营管理 - 预算管理 - 采购限额管理 -修改
  dyc_updatePurchaseLimitConfig: {
    control: 'dyc/saas/common/purchaseLimit/updatePurchaseLimitConfig'
  },
  // 运营管理 - 预算管理 - 采购限额管理 -查询联东部门下拉树
  dyc_selectLdOrgInfoListTree: {
    control: 'dyc/saas/common/user/selectLdOrgInfoListTree'
  },
  // 运营管理 - 预算管理 - 采购限额管理 -查询联东项目下拉树
  dyc_selectProjectInfoList: {
    control: 'dyc/saas/common/user/selectProjectInfoList'
  },
  // 运营管理 - 预算管理 - 采购限额管理 -查询外部单位
  dyc_qryExtOrgList: {
    control: 'dyc/saas/common/enterprise/qryExtOrgList'
  },
  // 运营管理 - 预算管理 - 采购限额管理 -查询联东项目下拉树
  dyc_purchaseLimitImport: {
    control: 'dyc/saas/common/purchaseLimit/purchaseLimitImport'
  },
  // 运营管理 - 预算管理 - 采购限额管理 -查询联东部门列表
  dyc_qryLdOrgInfoList: {
    control: 'dyc/saas/common/user/qryLdOrgInfoList'
  },
  // 运营管理 - 预算管理 - 成本控制量列表接口
  dyc_getCostControlPageList: {
    control: 'dyc/saas/common/costControl/getCostControlPageList'
  },
  // 运营管理 - 预算管理 - 成本控制量列表 导入
  dyc_costControlImport: {
    control: 'dyc/saas/common/costControl/costControlImport'
  },
  // 运营管理 - 预算管理 - 成本控制量 - 停用
  dyc_disableCostControlConfig: {
    control: 'dyc/saas/common/costControl/disableCostControlConfig'
  },
  // 运营管理 - 预算管理 - 成本控制量 - 启用
  dyc_enableCostControlConfig: {
    control: 'dyc/saas/common/costControl/enableCostControlConfig'
  },
  // 运营管理 - 预算管理 - 成本控制量 - 新增
  dyc_createCostControlConfig: {
    control: 'dyc/saas/common/costControl/createCostControlConfig'
  },
  // 运营管理 - 预算管理 - 成本控制量 - 供应商下拉数据
  dyc_qrySupDropDownPageList: {
    control: 'dyc/saas/common/enterprise/qrySupDropDownPageList'
  },
  // 运营管理 - 预算管理 - 成本控制量 - 供应商下拉数据
  dyc_queryMallBrandMappingList: {
    control: 'dyc/busicommon/commodity/queryMallBrandMappingList'
  },
  // 运营管理 - 预算管理 - 成本控制量 - 单品列表
  dyc_purchaseLimitSKuList: {
    control: 'dyc/zone/commodity/purchaseLimitSKuList'
  },
  // 运营管理 - 预算管理 - 成本控制量 - 修改
  dyc_updateCostControlConfig: {
    control: 'dyc/saas/common/costControl/updateCostControlConfig'
  },
  // 运营管理 - 预算管理 - 成本控制量 - 详情
  dyc_getCostControlDetail: {
    control: 'dyc/saas/common/costControl/getCostControlDetail'
  },
  // 运营管理 - 预算管理 - 成本控制量 - 历史记录
  dyc_getCostControlHisPageList: {
    control: 'dyc/saas/common/costControl/getCostControlHisPageList'
  },
  // 运营管理 - 预算管理 - 授信管理列表
  dyc_qryCreditInfoListPage: {
    control: 'dyc/saas/common/credit/qryCreditInfoListPage'
  },
  // 运营管理 - 预算管理 - 授信申请管理列表
  dyc_creditApplyApprovalList: {
    control: 'dyc/saas/common/credit/creditApplyApprovalList'
  },
  // 运营管理 - 预算管理 - 授信申请管理列表 - 提交审批
  dyc_bpmCreateApproval: {
    control: 'dyc/saas/common/credit/bpmCreateApproval'
  },
  // 运营管理 - 授信管理 - 授信管理列表 - 取消审批
  dyc_cancelCreditApproval: {
    control: 'dyc/saas/common/credit/cancelCreditApproval'
  },
  // 运营管理 - 询盘管理 - 询盘单管理
  dyc_inquirySheetList: {
    control: 'dyc/mall/commodity/manger/inquirySheetList'
  },
  // 运营管理 - 询盘管理 - 询盘单管理 - 询盘单详情查询1
  dyc_inquirySheetDetail: {
    control: 'dyc/mall/commodity/manger/inquirySheet'
  },
  // 运营管理 - 询盘管理 - 询盘单管理 - 询盘单详情查询2 - 报价单列表查询
  dyc_quotationListDetail: {
    control: 'dyc/mall/commodity/manger/quotationList'
  },
  // 账期结算设置
  dyc_qryFscSettlement: {
    control: 'dyc/fsc/qryFscSettlement'
  },
  // 修改账期结算设置
  dyc_updateFscSettlement: {
    control: 'dyc/fsc/updateFscSettlement'
  },
  // 报表
  dyc_getGetDailyOrdersDetail: {
    control: 'dyc/saas/common/reportForm/getGetDailyOrdersDetail'
  },
  // 园区信息查询
  dyc_getParkInfoList: {
    control: 'dyc/saas/common/park/getParkInfoList'
  },
  // 新增园区信息
  dyc_createParkInfo: {
    control: 'dyc/saas/common/park/createParkInfo'
  },
  // 修改园区信息
  dyc_updateParkInfo: {
    control: 'dyc/saas/common/park/updateParkInfo'
  },
  // 删除园区信息
  dyc_deleteParkInfo: {
    control: 'dyc/saas/common/park/deleteParkInfo'
  },
  // 园区信息详情
  dyc_getParkInfoDetail: {
    control: 'dyc/saas/common/park/getParkInfoDetail'
  },
  // 产品分类信息维护查询
  dyc_getProductClaList: {
    control: 'dyc/saas/common/productCategory/getList'
  },
  // 产品分类信息维护修改
  dyc_setProductClaEdit: {
    control: 'dyc/saas/common/productCategory/edit'
  },
  // 产品分类信息维护启用/暂停
  dyc_setProductClaupdate: {
    control: 'dyc/saas/common/productCategory/update'
  },
  // 报表
  dyc_getDataDailyOrdersList: {
    control: 'dyc/saas/common/reportForm/getDataDailyOrdersList'
  },
  // 订单报表
  dyc_querySalOrderListStatistics: {
    control: 'dyc/self/order/noauth/querySalOrderListStatistics'
  },
  // 园区导入
  dyc_importParkInfo: {
    control: 'dyc/saas/common/park/importParkInfo'
  },
  // 园区导入
  dyc_timeDataScreening: {
    control: 'dyc/saas/common/reportForm/noauth/timeDataScreening'
  },
  // 客户列表
  dyc_qryPurDropDownPageList: {
    control: 'dyc/saas/common/enterprise/qryPurDropDownPageList'
  },
  //新增门槛运费
  dyc_addFreightConfig: {
    control: 'dyc/saas/common/freight/addFreightConfig'
  },
  //查询门槛运费
  dyc_qryFreightConfigPageList: {
    control: 'dyc/saas/common/freight/qryFreightConfigPageList'
  },
  //修改门槛运费
  dyc_updateFreightConfig: {
    control: 'dyc/saas/common/freight/updateFreightConfig'
  },
  //删除门槛运费
  dyc_delFreightConfig: {
    control: 'dyc/saas/common/freight/delFreightConfig'
  },
  //三方修改门槛运费
  dyc_dealTrilateralFreightConfig: {
    control: 'dyc/saas/common/freight/dealTrilateralFreightConfig'
  },
  //批量导入运费
  dyc_importFreightConfig: {
    control: 'dyc/saas/common/freight/importFreightConfig'
  },
  //供应商列表
  //   dyc_qrySupDropDownPageList: {
  //     control: 'dyc/saas/common/enterprise/qrySupDropDownPageList'
  //   },
  // 在线询盘报价列表查询
  dyc_quotationList: {
    control: 'dyc/mall/commodity/manger/quotationList'
  },
  // 在线询盘详情查询
  dyc_inquirySheet: {
    control: 'dyc/mall/commodity/manger/inquirySheet'
  },
  // 在线询盘报价
  dyc_inquirySheetUpdate: {
    control: 'dyc/mall/commodity/inquirySheet/update'
  },
  // 在线询盘客户名称查询
  dyc_qryEnterpriseLabelInfoListPage: {
    control: 'dyc/saas/common/enterprise/qryEnquiriesLabelInfoListPage'
  },
  // 在线询盘人查询
  dyc_qryUserInfoByName: {
    control: 'dyc/mall/user/qryUserInfoByName'
  },
  // 转单校验
  dyc_inquirySheetCreateOrder: {
    control: 'dyc/mall/commodity/inquirySheet/createOrder'
  },
  // 释放限额
  dyc_releaseExtPurchaseLimit: {
    control: 'dyc/saas/common/purchaseLimit/releaseExtPurchaseLimit'
  },
  // 运营管理 - 询盘管理 - 询盘单管理(新) - 销售维度 - 询盘单列表查询
  dyc_qrySaleInquirySheets: {
    control: 'dyc/mall/commodity/inquirySheet/qrySaleInquirySheets'
  },
  // 运营管理 - 询盘管理 - 询盘单管理(新) - 销售维度 - 查询询盘详情列表
  dyc_qrySaleInquirySheetDetailList: {
    control: 'dyc/mall/commodity/qrySaleInquirySheetDetailList'
  },
  // 运营管理 - 询盘管理 - 询盘单管理(新) - 销售维度 - 编辑报价
  dyc_qrySaleInquirySheetDetailEdit: {
    control: 'dyc/mall/commodity/manger/detail'
  },
  // 运营管理 - 询盘管理 - 询盘单管理(新) - 销售维度 - 编辑报价 - 保存
  dyc_qrySaleInquirySheetDetailUpdate: {
    control: 'dyc/mall/commodity/inquirySheet/update'
  },
  // 运营管理 - 询盘管理 - 询盘单管理(新) - 新增 - 快速询价 - 快速询价查询
  dyc_qryOperationsQuickInquiries: {
    control: 'dyc/mall/commodity/os/quickinquiry/qryOperationsQuickInquiries'
  },
  // 运营管理 - 询盘管理 - 询盘单管理(新) - 新增 - 补充询盘信息- 询盘匹配商品
  dyc_qryInquiryMatchingSku: {
    control: 'dyc/mall/commodity/os/quickinquiry/qryInquiryMatchingSku'
  },
  // 运营管理 - 询盘管理 - 询盘单管理(新) - 新增 - 补充询盘信息- 询盘匹配商品(不验证)
  dyc_noauthQryInquiryMatchingSku: {
    // mock: true,
    control: '/dyc/mall/commodity/os/quickinquiry/noauth/qryInquiryMatchingSku'
  },
  // 运营管理 - 询盘管理 - 询盘单管理(新)
  dyc_newInquirySheetList: {
    control: 'dyc/mall/commodity/manger/list'
  },
  // 运营管理 - 询盘管理 - 询盘单管理(新)查询详情
  dyc_newInquirySheetDetail: {
    control: 'dyc/mall/commodity/manger/detail'
  },
  // 运营管理 - 询盘管理 - 询盘单管理(新)新增报价
  dyc_addInquirySheetDetail: {
    control: 'dyc/mall/commodity/inquirySheet/addInquirySheetDetail'
  },
  // 运营管理 - 询盘管理 - 询盘单管理(新)报价
  dyc_addInquirySheetUpdate: {
    control: 'dyc/mall/commodity/inquirySheet/update'
  },
  // 运营管理 - 询盘管理 - 询盘单管理 - 批量驳回/删除
  dyc_addInquirySheetUpdateBatch: {
    // mock:true,
    control: 'dyc/mall/commodity/inquirySheet/updateBatch'
  },
  // 运营管理 - 询盘管理 - 询盘单管理(新)下载模板
  dyc_addInquirySheetDownloadTemplate: {
    control: 'dyc/mall/commodity/manger/downloadTemplate'
  },
  // 运营管理 - 询盘管理 - 询盘单管理(新)转单校验
  dyc_createOrderCheck: {
    control: 'dyc/mall/commodity/inquirySheet/createOrderCheck'
  },
  // 查询购物车信息(询盘单)
  umc_qryOnlineBatchShoppingCartList: {
    // mock: true,
    control: 'dyc/saas/common/user/qryOnlineBatchShoppingCartList'
  },
  // 查询商品信息(代客下单确认页)
  umc_qryTransferOrderShoppingCartList: {
    // mock: true,
    control: 'dyc/saas/common/user/qryTransferOrderShoppingCartList'
  },
  // (成交价)
  umc_qryOnlineSavePrices: {
    // mock: true,
    control: 'dyc/mall/commodity/inquirySheet/savePrices'
  },
  // 下载报价单校验
  umc_qryOnlineDownloadCheck: {
    // mock: true,
    control: 'dyc/mall/commodity/manger/downloadCheck'
  },
  // 导出询价
  umc_batchImportQuotation: {
    // mock: true,
    control: 'dyc/mall/commodity/inquirySheet/batchImportQuotation'
  },
  // 品牌列表查询
  umc_batchQryBrandList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/noauth/qryBrandList'
  },
  // 查询当前用户查询方案
  umc_queryQueryGroup: {
    // mock: true,
    control: 'dyc/mall/commodity/complexQuery/queryQueryGroup'
  },
  // 查询运算符
  umc_queryOperators: {
    // mock: true,
    control: 'dyc/mall/commodity/complexQuery/queryOperators'
  },
  // 查询字段
  umc_queryConditionDictionary: {
    // mock: true,
    control: 'dyc/mall/commodity/complexQuery/queryConditionDictionary'
  },
  // 高级搜索保存
  umc_createQueryGroup: {
    // mock: true,
    control: 'dyc/mall/commodity/complexQuery/createQueryGroup'
  },
  // 删除某个方案
  umc_delQueryGroup: {
    // mock: true,
    control: 'dyc/mall/commodity/complexQuery/delQueryGroup'
  },
  // 批量搜索
  umc_complexQuery: {
    // mock: true,
    control: 'dyc/mall/commodity/manger/list/complexQuery'
  },
  // 风控-账期授信流程-授信管理-校验机构是否已经有授信存在API
  dyc_qryVerifyCreditInfoExists: {
    // mock: true,
    control: 'dyc/saas/common/credit/qryVerifyCreditInfoExists'
  },
  // 风控-账期授信流程-授信管理-授信审批表详情查询API
  dyc_qryCreditApplyInfo: {
    // mock: true,
    control: 'dyc/saas/common/credit/qryCreditApplyInfo'
  },
  // 风控-账期授信流程-查询账号下单数量和金额API
  dyc_qeryOrderNumberAccount: {
    // mock: true,
    control: 'dyc/saas/mall/order/qeryOrderNumberAccount'
  },
  // 风控-账期授信流程-提交
  dyc_addCreditApplyInfo: {
    // mock: true,
    control: 'dyc/saas/common/credit/addCreditApplyInfo'
  },
  // 风控-账期授信流程-调整授信详情
  dyc_qryCreditInfoDetail: {
    // mock: true,
    control: 'dyc/saas/common/credit/qryCreditInfoDetail'
  },
  // 风控-账期授信流程-修改授信详情
  dyc_updateCreditApplyInfo: {
    // mock: true,
    control: 'dyc/saas/common/credit/updateCreditApplyInfo'
  },
  // 风控-账期授信流程-调整提交
  dyc_saveAdjustCreditApplyInfo: {
    // mock: true,
    control: 'dyc/saas/common/credit/saveAdjustCreditApplyInfo'
  },
  // 匹配询盘单内存在的客户列表
  dyc_inquirySheetCustomers: {
    // mock: true,
    control: 'dyc/mall/commodity/inquirySheet/customers'
  },
  // 模板导入转订单
  dyc_inquirySheetImportToOrder: {
    // mock: true,
    control: 'dyc/mall/commodity/manger/importToOrder'
  },
  // 编辑询价
  dyc_inquirySheetEdit: {
    // mock: true,
    control: 'dyc/mall/commodity/inquirySheet/edit'
  },
  // 询盘导入
  dyc_importSkuToOrder: {
    // mock: true,
    control: 'dyc/mall/commodity/manger/importSkuToOrder'
  },
  // 获取毛利率默认配置
  dyc_getMinGrossProfitRate: {
    // mock: true,
    control: 'dyc/saas/common/user/getMinGrossProfitRate'
  },
  // 运营管理 - 分单BPM - 详情
  dyc_queryPurchaseContractApproval: {
    // mock: true,
    control: 'dyc/saas/mall/order/queryPurchaseContractApproval'
  },
  // 运营管理-机构及用户-客商基本信息管理列表
  low_qryMerchantListPage: {
    control: 'metaData/liandongMember/dycUmcMerchantQryListPageService/auto0006/qryMerchantListPage'
  },
  // code查询 
  low_queryCodeList0104: {
    // mock: true,
    control: 'metaData/liandongMember/dycUmcDicDataQueryService/auto0104/queryCodeList'
  },
  low_queryCodeList0103: {
    // mock: true,
    control: 'metaData/liandongMember/dycUmcDicDataQueryService/auto0103/queryCodeList'
  },
  // 更改供应商启禁用状态 (运营)
  low_operEnterpriseInfo: {
    control: 'metaData/liandongMember/dycUmcEnterpriseInfoOperService/auto0016/operEnterpriseInfo'
  },
  // 机构及用户-客商基本信息-详情
  low_qryEnterpriseInfoDetail: {
    control: 'metaData/liandongMember/dycUmcEnterpriseInfoQryDetailService/auto0094/qryEnterpriseInfoDetail'
  },
  // 机构及用户-销售名称list
  low_qryUserInfoListPage: {
    control: 'metaData/liandongMember/dycUmcUserInfoQryListPageService/auto0032/qryUserInfoListPage'
  },
  // 机构及用户-获取园区名称list
  low_getParkInfoList: {
    control: 'metaData/liandongMember/ldUmcGetParkInfoListService/auto0004/getParkInfoList'
  },
  // 机构及用户-获取园区详情
  low_getParkInfoDetail: {
    control: 'metaData/liandongMember/ldUmcGetParkInfoDetailService/auto0004/getParkInfoDetail'
  },
  // 机构及用户-修改信息
  low_updateEnterpriseInfo: {
    control: 'metaData/liandongMember/dycUmcEnterpriseInfoUpdateService/auto0014/updateEnterpriseInfo'
  },
  // 机构及用户-客商基本信息-批量新增供应商
  low_supplierUserImport: {
    control: 'metaData/liandongMember/ldUmcSupplierUserImportService/auto0001/supplierUserImport'
  },
  // 机构及用户-客商基本信息-批量修改标签
  low_importEnterpriseLabelInfo: {
    control: 'metaData/liandongMember/ldUmcImportEnterpriseLabelInfoService/auto0002/importEnterpriseLabelInfo'
  },
  // 机构及用户-客商基本信息-批量修改标签
  low_qryFileImpLogList0003: {
    control: 'metaData/liandongMember/dycCommonFileImpLogService/auto0003/qryFileImpLogList'
  },
  // 运营管理 - 法务审批BPM - 详情
  dyc_qrySaleContractOrderApproval: {
    // mock: true,
    control: 'dyc/saas/mall/order/qrySaleContractOrderApproval'
  }
};